var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{attrs:{"pill":"","variant":_vm.variant,"href":_vm.computedHref},on:{"click":function($event){return _vm.click()}}},[(_vm.icon && _vm.placement !== 'right')?_c('b-icon',{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" "),(_vm.icon && _vm.placement === 'right')?_c('b-icon',{attrs:{"icon":_vm.icon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }